<template>
  <div id="nav-block" class="nav-block-style">
    <search :searchFilter.sync="searchFilter" id="nav-search" />

    <v-tabs
      v-model="tabs"
      icons
      grow
      hide-slider
    >
      <v-tab href="#tab-chats" active-class="default-class tab-active">
        <v-icon v-if="unreadChats == 0">chat</v-icon>
        <v-badge v-else color="red" top overlap>
          <span slot="badge">{{ unreadChats > 99 ? '99+' : unreadChats }}</span>
          <v-icon>chat</v-icon>
        </v-badge>
      </v-tab>
      <v-tab href="#tab-calls" active-class="default-class tab-active">
        <v-icon v-if="missedCalls == 0">call</v-icon>
        <v-badge v-else color="red" top overlap>
          <span slot="badge">{{ missedCalls > 99 ? '99+' : missedCalls }}</span>
          <v-icon>call</v-icon>
        </v-badge>
      </v-tab>
      <v-tab href="#tab-contacts" active-class="default-class tab-active">
        <v-icon>contacts</v-icon>
      </v-tab>
    </v-tabs>

    <v-divider></v-divider>

    <div class="tab-items-block">
      <div class="tab-items-container">
        <v-tabs-items v-model="tabs" style="margin-bottom:32px;">
          <v-tab-item value='tab-chats' key=1 :transition="false" :reverse-transition="false">
            <tab-chats ref="chats" :filter="searchFilter" />
          </v-tab-item>
          <v-tab-item value='tab-calls' key=2 :transition="false" :reverse-transition="false">
            <tab-calls ref="calls" :filter="searchFilter" />
          </v-tab-item>
          <v-tab-item value='tab-contacts' key=3 :transition="false" :reverse-transition="false">
            <tab-contacts ref="contacts" :filter="searchFilter" />
          </v-tab-item>
        </v-tabs-items>
      </div>
    </div>


    <div class="fab-btn-wrapper" ref="fab">
      <v-btn
        color="primary"
        :key="activeFab.icon"
        v-model="fab"
        fab
        class="fab-btn"
        @click="fabClick"
      >
        <v-icon color="white">{{ activeFab.icon }}</v-icon>
      </v-btn>
  
      <div class="modal-wrap">
        <AddChat :visible.sync="showAddChat" />
        <AddCall :visible.sync="showAddCall" />
        <AddContact :visible.sync="showAddContact" ref="addContact"/>
      </div>
    </div>
  </div>
</template>

<style>
  .fab-btn-wrapper {
    align-self: flex-end;
    position: absolute; 
    left: 250px;
    bottom: 4px;
  }

  .arrow-down-wrapper .fab-btn { 
    width: 45px !important; 
    height: 45px !important;
  }

  .tab-items-block { 
    height: calc(100vh - 140px - var(--system-bar-height));
  }
  .tab-items-container { 
    height: inherit;
    background-color: var(--nav-background);
    overflow-x: hidden;
    overflow-y: overlay;
  }
  .tab-items-container:not(.focus):not(:hover)::-webkit-scrollbar {
    display: none;
  }

  .tab-font { 
    font-size:75%; 
  }
  .tab-icon { 
    font-size:125%; 
    margin-bottom: 6px; 
    color: var(--v-secondary-base) !important;
  }

  .tab-active .v-icon { 
    color:var(--v-primary-base) !important; 
  }
  .v-tabs__div i:hover {
    color:var(--v-primary-lighten1) !important;
  }

  #nav-block {
    background-color: var(--nav-background);
  }

  #nav-tabs .v-badge__badge { 
    height:18px !important; 
    width:18px !important;
    margin-top:1px;
    margin-right:1px;
  }
  #nav-tabs .v-badge__badge span { 
    font-size:65%; 
  }
</style>

<script>
  import Search from '@common/Search.vue'
  import TabChats from './navigation/TabChats.vue'
  import TabCalls from './navigation/TabCalls.vue'
  import TabContacts from './navigation/TabContacts.vue'
  import AddChat from '@dialogs/AddChat.vue'
  import AddCall from '@dialogs/AddCall.vue'
  import AddContact from '@dialogs/AddContact.vue'

  export default {
    name: 'navigation-view',
    components: { 
      Search, 
      TabChats, 
      TabCalls, 
      TabContacts, 
      AddChat, 
      AddCall, 
      AddContact 
    },
    data () {
      return {
        showAddChat: false,
        showAddCall: false,
        showAddContact: false,
        missedCalls: 0,
        fab: false,
        tabs: null,
        showAddDialog: {
          'tab-chats': false,
          'tab-calls': false,
          'tab-contacts': false,
        },
        searchFilter:''
      }
    },
    methods: {
      fabClick(e) {
        // fix issue with auto closing of 'click-outside' event
        e.stopPropagation()

        this.showAddChat = false
        this.showAddCall = false
        this.showAddContact = false
      
        switch (this.tabs) {
          case 'tab-chats': this.showAddChat = true; break
          case 'tab-calls': this.showAddCall = true; break
          case 'tab-contacts': this.showAddContact = true; break
        }
      },
      chatChanged(args) {
        this.$refs.chats.updateChat(args.chatId, args.messageId)
      },
      recentChanged() {
        console.log('-- nav: recentChanged')
        this.$refs.calls.fetchRecents()
      },
      clearSearchFilter() {
        this.$nextTick(() => this.searchFilter = '')
      },
      openAddContact(contactId) {
        this.$refs.addContact.setContactId(contactId)
        this.showAddContact = true
      },
      updateMissedCalls() {
        const calls = this.$store.state.recents
        this.missedCalls = calls.filter(c => c.read == false).length
      },
      contactBlocked(id){
        this.$refs.contacts.contactBlocked(id)
        this.$refs.calls.contactBlocked(id)
      },
      contactUnblocked(id) {
        this.$refs.contacts.contactUnblocked(id)
        this.$refs.calls.contactUnblocked(id)
      },
      contactsChanged() {
        this.$refs.chats.fetchChats()
        this.$refs.calls.fetchRecents()
      }
    },
    computed: {
      activeFab () {
        switch (this.tabs) {
          case 'tab-chats':    return { icon: 'insert_comment' }
          case 'tab-calls':    return { icon: 'phone' }
          case 'tab-contacts': return { icon: 'person_add' }
          default: 
        }
        return {}
      },
      unreadChats() {
        const chats = this.$store.state.chats
        return chats.filter(it => it.unread > 0).length
      }
    },
    created() {
      // TODO: it's a hack to load contacts before recents
      this.$store.dispatch('fetchContacts')
    },
    mounted() {
      this.updateMissedCalls()
    },
    watch: {
      showAddContact(newValue, oldValue) {
        if (oldValue == true) {
          this.$refs.contacts.fetchContacts()
        }
      },
      tabs(newValue, oldValue) {
        if (newValue === 'tab-calls' && this.missedCalls > 0) {
          this.$refs.calls.markUnreadCalls(() => {
            this.updateMissedCalls()
            console.log('this.missedCalls', this.missedCalls)
          })
        }
      }
    }
  }
</script>